document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('video')) {
        const vids = Array.from(document.querySelectorAll('video'));
        if (vids) {
            vids.forEach((el) => {
                setTimeout(() => {
                    if (el.networkState > 2) {
                        if (el.parentNode.children[5].tagName === 'BUTTON') {
                            el.parentNode.children[5].style.display = 'none';
                        }
                        if (el.poster) {
                            el.parentNode.style.backgroundImage = 'url(' + el.poster + ')';
                            el.parentNode.style.backgroundPosition = el.getAttribute('data-poster-object-position');
                            el.parentNode.style.backgroundSize = 'cover';
                            el.style.opacity = '0';
                        }
                    }
                }, 5000);
            });
        }
        //Play/Pause Toggle - on any click inside the cover, if not a link, initiate the play/pause toggle
        const covers = Array.from(document.querySelectorAll('.wp-block-cover'));
        let clickCount;
        if (!isReduced) {
            clickCount = 0;
        } else {
            clickCount = 1;
            const coversWithVideo = document.querySelectorAll('.wp-block-cover__video-background');
            coversWithVideo.forEach(el => {
                videoInit(el, true);
                el.removeAttribute('autoplay');
                el.removeAttribute('loop');
            });
        }
        covers.forEach(cover => {
            let coverVideo = cover.querySelector('video');
            let coverButton = cover.querySelector('button');
            if (coverVideo !== null) {
                cover.addEventListener('click', playpause);
                coverVideo.addEventListener('ended', handleVideoEnded);
            }
        });
        function videoInit(video, playFlag = false) {
            const btnEl = document.querySelector('button.control-bt');
            if (playFlag == true) {
                if (btnEl.classList.contains('pause')) {
                    btnEl.classList.remove('pause');
                    btnEl.classList.add('play');
                    btnEl.setAttribute('aria-label', 'Video Paused.');
                    video.pause();
                }
            } else {
                if (btnEl.classList.contains('play')) {
                    btnEl.classList.remove('play');
                    btnEl.classList.add('pause');
                    btnEl.setAttribute('aria-label', 'Video Playing.');
                    video.play();
                }
            }

        }

        function handleClickAfterReset(e) {
            const cKids = Array.from(this.children);
            const coverVideo = cKids.filter(vid => vid.localName === 'video')[0];
            const coverButton = cKids.filter(btn => btn.localName === 'button')[0];
            clickCount = 1;
            coverButton.classList.remove('refresh');
            videoInit(coverVideo);
            playpause(this);
            coverVideo.removeEventListener('ended', handleVideoEnded);
            this.removeEventListener('click', handleClickAfterReset);
        }

        function handleVideoEnded() {
            const cKids = Array.from(this.parentNode.children);
            const coverButton = cKids.filter(btn => btn.localName === 'button')[0];
            if (clickCount < 1) {
                clickCount = 1;
            }
            if (!coverButton.classList.contains('refresh')) {
                coverButton.classList.add('refresh');
                coverButton.setAttribute('aria-label', 'Video has ended.');
            }
            this.parentNode.addEventListener('click', handleClickAfterReset);
        }

        //play pause toggle for video covers
        function playpause(el) {
            //For each link in the cover, execute the link and ignore the play/pause toggle function
            const links = document.querySelectorAll('.wp-block-cover ul a');
            links.forEach(link => link.addEventListener('click', e => e.stopPropagation()));
            //Check to see if the target element is the cover block,
            const target = (typeof el.target !== 'undefined') ? el.target : el;
            if (target.classList.contains('wp-block-cover') || target.classList.contains('wp-block-cover__video-background')) {
                // If it is, pull the video and the button elements from the children and put them through the toggle function
                const tKids = Array.from(target.children);
                const video = tKids.filter(vid => vid.localName === 'video');
                const button = tKids.filter(btn => btn.localName === 'button');
                if (video.length > 0) {
                    toggle(video, button);
                }
            } else {
                //If it isn't, loop of the elements parent,
                let parent = target.parentNode;
                do {
                    //Check if the element's parent is the wp-cover block,
                    if (parent.classList.contains('wp-block-cover')) {
                        // if it is, pull the video and the button elements from the children and put them through the toggle function
                        const pKids = Array.from(parent.children);
                        const video = pKids.filter(vid => vid.localName === 'video');
                        const button = pKids.filter(btn => btn.localName === 'button');
                        if (video.length > 0) {
                            toggle(video, button);
                        }
                        return true;
                    }
                    // if it isn't go up another level and rerun the check
                    parent = parent.parentNode;
                } while (parent);
                return false;
            }

            //controls the video and button attributes
            function toggle(vid, btn) {
                if (clickCount == 0) {
                    //Video initial
                    btn[0].setAttribute('aria-label', 'Video Paused.');
                    btn[0].classList.remove('pause');
                    btn[0].classList.add('play');
                    vid[0].pause();
                } else if (clickCount % 2 == 0) {
                    //From initial to pause
                    btn[0].setAttribute('aria-label', 'Video Paused.');
                    btn[0].classList.remove('pause');
                    btn[0].classList.add('play');
                    vid[0].pause();
                } else {
                    //From pause to play
                    btn[0].setAttribute('aria-label', 'Video Playing.');
                    btn[0].classList.remove('play');
                    btn[0].classList.add('pause');
                    vid[0].play();
                }
                clickCount++;
            }
        }
    }
});